/** Renders an exercise prompt, drawing BLANK markers as empty slots (or given content). */
import type { ReactNode } from 'react';
import { BLANK } from '../../core/exercises.ts';

export function PromptText({ text, renderBlank }: { text: string; renderBlank?: (index: number) => ReactNode }) {
  const parts = text.split(BLANK);
  return (
    <p className="prompt">
      {parts.map((part, i) => (
        <span key={i}>
          {part}
          {i < parts.length - 1 &&
            (renderBlank ? renderBlank(i) : <span className="prompt__blank" aria-label="пропуск" />)}
        </span>
      ))}
    </p>
  );
}
